import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import { Size } from '@constants/common/ui.constants';

const useStyles = makeStyles<{ isActive: boolean; size: Size }>()(
  (theme, { isActive, size }) => ({
    box: {
      ...dFlex(),
      flexDirection: 'column',
      gap: 8,
      padding: 16,
      background: theme.secondary.s1,
      borderRadius: theme.borderRadius.md,
      transition: 'all 0.25s ease-in-out',

      '&:hover': {
        background: theme.secondary.s4,
      },

      ...(isActive && {
        background: theme.primary.p3,

        '&:hover': {
          background: theme.primary.p3,
        },
      }),

      ...(size === Size.Small && {
        padding: 8,
      }),
    },
  }),
);

export default useStyles;
